import * as React from "react";
import * as Scrivito from "scrivito";
import { useEffect, useMemo, useState } from "react";

import { getBlobInfo, getPageLink, getSearchedPartOfText } from "utils";
import { Icon, HighlightText } from "components";

import { useTranslate } from "hooks";
import styles from "./SearchPage.module.scss";

export const SearchResult = Scrivito.connect(({ item, searchedString }) => {
  const translate = useTranslate();
  const [searchedText, setSearchedText] = useState(null);
  const [{ icon, info }, setBlob] = useState({
    icon: "",
    info: { size: "", type: "" },
  });

  useEffect(() => {
    Scrivito.load(() => Scrivito.extractText(item)).then((text) => {
      setSearchedText(getSearchedPartOfText(text, searchedString));
    });

    const blob = item.get("blob");
    if (blob) {
      Scrivito.load(() => item.get("blob").raw().contentLength()).then(
        (blobLength) => {
          const blobInfo = getBlobInfo(blob, blobLength);
          setBlob(blobInfo);
        },
      );
    }
  }, [item, searchedString]);

  const navImage = useMemo(() => item.get("navigationImage") || null, [item]);

  return (
    <div className="my-3">
      <Scrivito.LinkTag to={getPageLink(item)}>
        <h5 className="font-weight-normal">
          <HighlightText
            text={item.get("title") || translate("PAGE_NO_PAGE_TITLE")}
            symbolsToHighlight={searchedString.split(/\s+/)}
          />
        </h5>
      </Scrivito.LinkTag>
      <div className="d-flex">
        {navImage && (
          <Scrivito.LinkTag to={getPageLink(item)}>
            <Scrivito.ImageTag
              content={navImage}
              className={styles.resultImage}
              alt={navImage.get("alternativeText")}
            />
          </Scrivito.LinkTag>
        )}
        {icon && (
          <Scrivito.LinkTag to={getPageLink(item)}>
            <Icon
              iconName={icon}
              prefix="fa-thin"
              className="icon-32 pl-3 pr-4"
            />
          </Scrivito.LinkTag>
        )}
        <div className="d-flex flex-column">
          {info.size && info.type && (
            <span>
              {translate("FILE_TYPE")}: {translate(info.type)} /{" "}
              {translate("FILE_SIZE")}: {info.size}
            </span>
          )}
          {searchedText && (
            <HighlightText
              text={searchedText}
              symbolsToHighlight={searchedString.split(/\s+/)}
            />
          )}
        </div>
      </div>
    </div>
  );
});
